import React from 'react';
import OfferPerformanceSegmentedTabs from './OfferPerformanceSegmentedTabs';

/** AppHeader imports this name; UI lives in OfferPerformanceSegmentedTabs. */
const OfferPerformanceTabs = () => <OfferPerformanceSegmentedTabs />;

export default OfferPerformanceTabs;
